import { Media } from 'graphql.generated';
import { FloorPlanExternal, PartialLinkData } from './FloorPlans.types';

export const mapLinksAndPDFsToExternal = (
    pdfs: Media[],
    links: PartialLinkData[]
): FloorPlanExternal[] => {
    const mappedPDFs = pdfs.map((item) => ({
        type: 'pdf',
        url: item.original,
        caption: item.caption
    }));

    const mappedLinks = links.map((item) => ({
        type: 'link',
        url: item.url,
        caption: item.label
    }));

    return [...mappedPDFs, ...mappedLinks] as FloorPlanExternal[];
};
